const errorCodes = {
  'OSR-000': 'Prosimy skontaktować się z administratorem strony.',
  'OSR-001': 'Element nie został znaleziony.',
  'OSR-002': 'Brak wymaganych uprawnień.',
  'OSR-003': 'Nie udało się załadować danych.',
  'OSR-004': 'Pole jest wymagane.',
  'OSR-005': 'Podany adres email jest nieprawidłowy.',
  'OSR-006': 'Zgoda jest wymagana.',
  'OSR-007': 'Podany adres email jest nieprawidłowy.',
  'OSR-008': 'Nieprawidłowy parametr żądania.'
};

export default errorCodes;
